import { SearchIcon, VideoIcon, WebinarIcon } from '@approvalmax/ui';

import { messages } from './AdditionalResources.messages';

export const links = [
    {
        title: messages.videoTutorials,
        link: 'https://www.youtube.com/@Approvalmax/videos?utm_source=starterguide&utm_medium=cta',
        Icon: VideoIcon,
    },
    {
        title: messages.knowledgeBase,
        link: 'https://support.approvalmax.com/portal/en/kb/approvalmax-1?utm_source=starterguide&utm_medium=cta',
        Icon: SearchIcon,
    },
    {
        title: messages.webinars,
        link: 'https://approvalmax.com/resources/product-demos?utm_source=starterguide&utm_medium=cta',
        Icon: WebinarIcon,
    },
];
